;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');
	var Collection = APP.module('Collection');
	Router.Registration = Marionette.AppRouter.extend({
		permissions: {
			'registration':             2,
			'registrationStep1':        2,
			'registrationStep2':        2,
			'registrationSSO':          2,
			'registrationCreateLeague': 1,
			'registrationPeakTeam':     2,
			'registerForGame':          8,
			'registerRecover':          1
		},
		appRoutes: {
			'registration': 'followToFirstStep',
			'registration/step_1': 'registrationStep1',
			'registrationSSO': 'registrationSSO',
			'registration/step_2': 'registrationStep2',
			'registration/create_league': 'registrationCreateLeague',
			'registration/pick_team': 'registrationPeakTeam',
			'registration/for_game': 'registerForGame',
			'registration/recovered': 'registerRecover'
		}
	});

}(window, APP, Backbone, Marionette, $, _));